// let domainkey = ''
// if(process.env.NODE_ENV === 'development')
// {
//     domainkey='flowzcluster.tk'
// }


module.exports = {
    default: {
        loginUrl: 'https://api.' + process.env.VUE_APP_DOMAINKEY + '/auth/api/login',
        socketURI: 'wss://ws.' + process.env.VUE_APP_DOMAINKEY + ':4046',
        // socketURI: 'http://localhost:4046',
        signupUrl: 'https://api.' + process.env.VUE_APP_DOMAINKEY + '/auth/api/setup',
        serviceUrl: 'https://api.' + process.env.VUE_APP_DOMAINKEY + '/jsforce/Service__c?$limit=50&Type__c=customer&Department__c=a1D21000000XV9A',
        userDetail: 'https://api.' + process.env.VUE_APP_DOMAINKEY + '/auth/api/userdetails',
        userDetailsByEmail: 'https://api.' + process.env.VUE_APP_DOMAINKEY + '/auth/api/userdetailsbyemail',
        jobDetaills: 'https://api.' + process.env.VUE_APP_DOMAINKEY + '/pow/jobs',
        pyExtraction: process.env.VUE_APP_SERVERKEY + '/process',
        videoCreate: process.env.VUE_APP_SERVERKEY + '/CreateVideo'
    }
}